/**
 * API URLs - configurable via .env for local vs deployed environments.
 *
 * IMPORTANT: When running on the HTTPS DDEV site the hostname check ALWAYS
 * wins over any .env value.  This prevents mixed-content errors where the
 * browser refuses to load http://localhost:5002/speech-xxx.mp3 from an
 * https:// page.  All requests are proxied by nginx on the same origin:
 *   /api/* → http://127.0.0.1:5000  (backend + TTS audio files)
 *   /ai/*  → http://127.0.0.1:5001  (AI service)
 *
 * On plain localhost the .env values (or sensible defaults) are used instead.
 */
const isProductionSite = typeof window !== 'undefined' && (
  window.location?.hostname === 'learnwithavatar.ddev.site' ||
  window.location?.hostname === 'my-avatar.in' ||
  window.location?.hostname === 'www.my-avatar.in'
);

export const BACKEND_URL = isProductionSite
  ? '/api'
  : (process.env.REACT_APP_BACKEND_URL || 'http://localhost:5002');

/** Base URL for static assets (speech MP3s, GLB models). On production these are
 *  served by Nginx at the site root (/speech-xxx.mp3), NOT under /api. */
export const STATIC_BASE = isProductionSite
  ? ''
  : (process.env.REACT_APP_BACKEND_URL || 'http://localhost:5002');

export const AI_URL = isProductionSite
  ? '/ai'
  : (process.env.REACT_APP_AI_URL || 'http://localhost:5003');
